import DisplayView from "../../../../../components/DisplayView";
import {IconMapButton} from "../../../../../components/buttons/IconButtons";
import SearchSimple from "../../../../../components/SearchSimples/SearchSimple";
import React from "react";
import DateFilter from "./DateFilter";

/**
 * @Email : azapata@ibl.mx
 * @Author: Ferro Zapata Arnulfo
 * @jobTittle: Full Stack Developer
 *
 */
const AttendanceHead = ({
                            view,
                            setView,
                            setBodyForExport,
                            setSearchResults,
                            searchElement,
                            setSearchElement,
                            option,
                            rowsPerPage,
                            attendanceStartDate,
                            attendanceEndDate,
                            selectedOption,
                            setSimpleSearch,
                            searchClean,
                            setSearch,
                            contractorId,
                            supplierId,
                            search,
                            setSendSimpleSearch,
                            finalArray,
                            setSelectedOption,
                            selectedDate,
                            setSelectedDate,
                            handleView,
                            handleChange
                        }) => {
    return(
        <>
            <div className={'d-flex'}>
                {view && setView &&
                    <DisplayView view={view} setView={handleView} iconRight={IconMapButton} className={'m-0'}/>
                }
                <div className='w-100 ml-2'>
                    <SearchSimple
                        id={'txt_py_search_simple'}
                        setBodyForExport={setBodyForExport}
                        setSearchResults={setSearchResults}
                        searchElement={searchElement}
                        setSearchElement={setSearchElement}
                        optionTable={option}
                        rowsPerPage={rowsPerPage}
                        attendanceStartDate={attendanceStartDate}
                        attendanceEndDate={attendanceEndDate}
                        attendanceSearchType={selectedOption}
                        setSimpleSearch={setSimpleSearch}
                        searchClean={searchClean}
                        setSearch={setSearch}
                        contractorId={contractorId}
                        supplierId={supplierId}
                        disabled={search}
                        setSendSimpleSearch={setSendSimpleSearch}
                    />
                </div>
            </div>
            {finalArray.length <= 0 && (
                <div className={"mt-4 p-0 m-0"}>
                    <DateFilter
                        selectedOption={selectedOption}
                        setSelectedOption={setSelectedOption}
                        selectedDate={selectedDate}
                        setSelectedDate={setSelectedDate}
                        handleChange={handleChange}
                    />
                </div>
            )}
        </>


    )
}

export default AttendanceHead
